import React, { Component } from 'react';

export default class BreadCrumbs extends Component {
    constructor(props) {
        super(props);

        this.props = props;
    }

    render() {
        const renderItems = () => {
            return this.props.items.map((item, index) => {
                const key = `bc-${index}`;
                if (index === this.props.items.length - 1) {
                    return (
                        <li key={key} className="active">
                            {' '}
                            {item.label}{' '}
                        </li>
                    );
                } else {
                    return (
                        <li key={key}>
                            <a href={item.href}>{item.label}</a>
                        </li>
                    );
                }
            });
        };

        return <ol className="breadcrumb">{renderItems()}</ol>;
    }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumbs-component.js